interface Assessment {
  id: number;
  date: string;
  responder?: string;
}

interface AssessmentSelectorProps {
  assessments: Assessment[];
  selectedIds: number[];
  onPrimarySelect: (id: number) => void;
  onComparisonSelect: (id: number | null) => void;
  onReset: () => void;
}

export function AssessmentSelector({
  assessments,
  selectedIds,
  onPrimarySelect,
  onComparisonSelect,
  onReset,
}: AssessmentSelectorProps) {
  return (
    <div
      className="flex flex-wrap gap-4 items-center bg-white p-4 rounded-lg border shadow-sm"
      style={{ borderColor: "#E2E8F0" }}
    >
      <div className="flex flex-col gap-1">
        <label
          htmlFor="primary-assessment"
          className="text-xs font-bold text-slate-500 uppercase tracking-wider"
        >
          Primary Assessment
        </label>
        <select
          id="primary-assessment"
          value={selectedIds[0] ?? ""}
          onChange={(e) => onPrimarySelect(parseInt(e.target.value, 10))}
          className="px-3 py-2 border rounded-md text-sm font-medium focus:ring-2 focus:ring-blue-500 outline-none"
          style={{ borderColor: "#CBD5E1", color: "#1A202C" }}
        >
          {assessments.map((item) => (
            <option key={item.id} value={item.id}>
              {item.date} {item.responder && `- ${item.responder}`}
            </option>
          ))}
        </select>
      </div>

      <div className="flex flex-col gap-1">
        <label
          htmlFor="comparison-assessment"
          className="text-xs font-bold text-slate-500 uppercase tracking-wider"
        >
          Comparison Assessment
        </label>
        <select
          id="comparison-assessment"
          value={selectedIds[1] ?? ""}
          onChange={(e) => {
            const val = e.target.value;
            onComparisonSelect(val === "" ? null : parseInt(val, 10));
          }}
          className="px-3 py-2 border rounded-md text-sm font-medium focus:ring-2 focus:ring-blue-500 outline-none"
          style={{ borderColor: "#CBD5E1", color: "#1A202C" }}
        >
          <option value="">None (Single View)</option>
          {assessments
            .filter((item) => item.id !== selectedIds[0])
            .map((item) => (
              <option key={item.id} value={item.id}>
                {item.date} {item.responder && `- ${item.responder}`}
              </option>
            ))}
        </select>
      </div>

      <div className="ml-auto">
        {selectedIds.length > 0 && (
          <button
            onClick={onReset}
            className="text-xs font-bold text-blue-600 hover:text-blue-800 uppercase tracking-wider"
          >
            Reset to Latest
          </button>
        )}
      </div>
    </div>
  );
}
